/* tslint:disable */
/* eslint-disable */
export enum ServiceOrderType {
  Aircraft = 'AIRCRAFT',
  Client = 'CLIENT',
}
